export default __webpack_public_path__ + "static/media/image-register-not-available.8439baae.svg";